import React from 'react';
import ContactSupportOutlinedIcon from '@mui/icons-material//ContactSupportOutlined';
import { Box, Tooltip, Typography } from '@mui/material';
import { HOW_DO_I_USE_THIS, HOW_DO_I_USE_THIS_INSTRUCTIONS } from 'common/constants/process-management';
import theme from 'theme';
import { HowDoIUseThisDocumentsUploadSectionStyles } from './styles';

const HOW_DO_I_USE_THIS_TOOLTIP = (
  <ol>
    {HOW_DO_I_USE_THIS_INSTRUCTIONS.map(item => (
      <li key={item.id} style={{ color: theme.palette.white }}>
        {item.instruction}
      </li>
    ))}
  </ol>
);

const HowDoIUseThisDocumentsUploadSection = () => {
  const classes = HowDoIUseThisDocumentsUploadSectionStyles();

  return (
    <Box className={classes.howDoIUseThisBox}>
      <ContactSupportOutlinedIcon className={classes.howDoIUseThisIcon} />
      <Tooltip title={HOW_DO_I_USE_THIS_TOOLTIP} arrow placement="bottom" classes={{ tooltip: classes.tooltip }}>
        <Typography className={classes.howDoIUseThisText}>{HOW_DO_I_USE_THIS}</Typography>
      </Tooltip>
    </Box>
  );
};

export default HowDoIUseThisDocumentsUploadSection;
